import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useGetPlace from 'dataProvider/hooks/useGetPlace';
import useResultProvider from '../../dataProvider/hooks/useResultProvider';
import { getSite } from '../../constants/sites';
import { PactometroBarrasSiNo } from './barrasSiNo';

import { SUBTYPES } from '../../envs';
import { getResultOrigin } from '../../dataProvider';
import LoadingPlaceholder from '../loadingPlaceholder';

import './style.scss';
import HeaderPoliticians from './headerPoliticians';
import PactometroCheck from './checks';
import partiesSimulatorJson from '../../partiesSimulator.json';

const PactometroSiNoContainer = ({ match }) => {
  const { year, type, electionNumber, placeId, town } = match.params;
  const [resultOrigin, setResultOrigin] = useState({});
  const place = useGetPlace(placeId);
  const [parties, setParties] = useState([]);
  const [headSelected, setHeadSelected] = useState(false);

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placeId)
      .then(_historicResult => {
        const historicResult = {
          ..._historicResult,
          primary: {
            ..._historicResult.primary
          }
        };
        setResultOrigin(historicResult);
      })
      .catch(err => {
        console.log(err);
      });
  }, [electionNumber, placeId, type, year]);

  const site = getSite();
  const { result: dataResult } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: SUBTYPES.SINGLE,
    electionPlace: placeId,
    electionNumber,
    placeId,
    details: Boolean(town),
    site
  });
  const filterData = dataResult?.partiesResult?.filter(
    current => current.seats >= 1
  );

  const partiesSimulator = partiesSimulatorJson;

  useEffect(() => {
    if (partiesSimulator[placeId] && dataResult?.partiesResult?.length) {
      const partiesData = dataResult.partiesResult.map(item => {
        const party = partiesSimulator[placeId].find(
          party => party.id === item.id
        );
        return { ...party, data: item, inFavor: [item], against: [] };
      });
      setParties(partiesData.sort((a, b) => b.seats - a.seats).slice(0, 2));
      setHeadSelected(partiesData[0].id);
    }
  }, [partiesSimulator, dataResult, placeId]);
  useEffect(() => {
    if (parties.length) {
      setParties(
        parties.map(item => ({ ...item, inFavor: [item.data], against: [] }))
      );
    }
  }, [headSelected]);
  const selectedItem = parties?.find(item => item.id === headSelected);

  if (!dataResult || !resultOrigin.primary) {
    return <LoadingPlaceholder />;
  }
  return (
    <>
      {dataResult && (
        <>
          <section className="PactosSiNo">
            <HeaderPoliticians
              parties={parties}
              totalSeat={dataResult.totalSeats}
              placeName={place?.name}
              selectedId={headSelected || parties[0]?.id}
              onChange={event => {
                setHeadSelected(event);
              }}
            />
            <PactometroBarrasSiNo
              selecteds={selectedItem?.inFavor || []}
              selectedsNo={selectedItem?.against || []}
              totalSeat={dataResult.totalSeats}
            />

            <div className="pactosScrollContent">
              <PactometroCheck
                data={filterData}
                selecteds={selectedItem?.inFavor || []}
                selectedsNo={selectedItem?.against || []}
                selectedId={headSelected || parties[0]?.id}
                onChange={event => {
                  const selectedsFavors = (selectedItem?.inFavor || []).filter(
                    item => item.id !== event.item.id
                  );
                  const selectedsNoFavors = (
                    selectedItem?.against || []
                  ).filter(item => item.id !== event.item.id);
                  if (event.pacto === 1) {
                    setParties(
                      parties.map(party => {
                        if (party.id === selectedItem.id) {
                          return {
                            ...party,
                            inFavor: [...selectedsFavors, event.item],
                            against: [...selectedsNoFavors]
                          };
                        }
                        return party;
                      })
                    );
                  } else if (event.pacto === 0) {
                    setParties(
                      parties.map(party => {
                        if (party.id === selectedItem.id) {
                          return {
                            ...party,
                            inFavor: [...selectedsFavors],
                            against: [...selectedsNoFavors, event.item]
                          };
                        }
                        return party;
                      })
                    );
                  } else {
                    setParties(
                      parties.map(party => {
                        if (party.id === selectedItem.id) {
                          return {
                            ...party,
                            inFavor: [...selectedsFavors],
                            against: [...selectedsNoFavors]
                          };
                        }
                        return party;
                      })
                    );
                  }
                }}
              />
            </div>
            <p className="txt-footer">
              Seleccione uno de los dos candidatos y pulse en los botones para
              votar sí, no o abstención. El candidato o candidata podrá gobernar
              en primera votación si consigue la mayoría absoluta o en segunda
              votación si consigue más síes que noes.
            </p>
          </section>
        </>
      )}
    </>
  );
};

PactometroSiNoContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      year: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      electionNumber: PropTypes.string.isRequired,
      province: PropTypes.string,
      navigableMode: PropTypes.string.isRequired,
      placeId: PropTypes.string.isRequired,
      chartType: PropTypes.string,
      town: PropTypes.string,
      country: PropTypes.string
    }).isRequired
  }).isRequired
};

export default PactometroSiNoContainer;
